import { createTheme } from "@mui/material";
import { deDE } from "@mui/x-date-pickers/locales";
import { theme } from "../../theme/main";

export const whiteTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#242B59",
    },
    secondary: {
      main: "#000",
    },
    chipPrimary: {
      main: "red",
    },
    deDE,
  },

  mode: "light",
  customSizes: {
    medium: "750px",
    small: "400px",
    large: "1000px",
  },
  ...theme.light,
});
